import api from './api';
import type { Abrechnungsposten, DebitorZuordnung, Tagesabrechnung } from './erpTypes';

/** Tagesabrechnung (ADR 0014): Posten, Laeufe, Zuordnungen. */

export const QUELLE_LABEL: Record<string, string> = {
  intern: 'Intern',
  'platform-admin': 'Plattform-Abrechnung',
  core: 'SecTepe Core',
  snapscan: 'SnapScan',
  'appointment-booking': 'Terminbuchung',
  'app-marketplace': 'App-Marktplatz',
  'cti-sandbox': 'Malware-Sandbox',
};

export const POSTEN_STATUS_LABEL: Record<string, string> = {
  offen: 'Offen',
  abgerechnet: 'Abgerechnet',
  storniert: 'Storniert',
  fehler: 'Fehler',
};

export const LAUF_STATUS_LABEL: Record<string, string> = {
  vorschau: 'Vorschau',
  laeuft: 'Läuft',
  abgeschlossen: 'Abgeschlossen',
  teilweise_fehler: 'Teilweise Fehler',
  freigegeben: 'Freigegeben',
};

export const ZEILE_STATUS_LABEL: Record<string, string> = {
  vorschau: 'Vorschau',
  entwurf: 'Entwurf',
  ausgestellt: 'Ausgestellt',
  bezahlt: 'Bezahlt',
  fehler: 'Fehler',
  uebersprungen: 'Übersprungen',
};

export const ZEILE_ART_LABEL: Record<string, string> = {
  posten: 'Posten',
  auftrag: 'Auftrag',
  projekt: 'Projekt',
};

export interface PostenFilter {
  status?: string;
  quelle?: string;
  companyId?: string;
  vorgangRef?: string;
}

const abrechnungService = {
  async posten(filter?: PostenFilter): Promise<Abrechnungsposten[]> {
    const response = await api.get('/abrechnung/posten', { params: filter || {} });
    return response.data;
  },
  async postenAnlegen(daten: Record<string, unknown>): Promise<Abrechnungsposten> {
    const response = await api.post('/abrechnung/posten', daten);
    return response.data;
  },
  async postenStornieren(id: string): Promise<Abrechnungsposten> {
    const response = await api.post(`/abrechnung/posten/${id}/storno`);
    return response.data;
  },
  async laeufe(): Promise<Tagesabrechnung[]> {
    const response = await api.get('/abrechnung/laeufe');
    return response.data;
  },
  async lauf(tag: string): Promise<Tagesabrechnung> {
    const response = await api.get(`/abrechnung/laeufe/${tag}`);
    return response.data;
  },
  async starten(tag: string, dryRun: boolean): Promise<Tagesabrechnung & { ergebnis: NonNullable<Tagesabrechnung['ergebnis']> }> {
    const response = await api.post(`/abrechnung/laeufe/${tag}/starten`, { dryRun });
    return response.data;
  },
  async freigeben(tag: string): Promise<Tagesabrechnung> {
    const response = await api.post(`/abrechnung/laeufe/${tag}/freigeben`);
    return response.data;
  },
  async zuordnungen(filter?: { offen?: boolean }): Promise<DebitorZuordnung[]> {
    const response = await api.get('/abrechnung/zuordnungen', { params: filter?.offen ? { offen: 'true' } : {} });
    return response.data;
  },
  async zuordnen(id: string, companyId: string): Promise<DebitorZuordnung> {
    const response = await api.put(`/abrechnung/zuordnungen/${id}`, { companyId });
    return response.data;
  },
};

export default abrechnungService;
